import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import './ProductImages.css';

interface ProductImagesProps {
  images: string[];
  selectedImage: number;
  onImageSelect: (index: number) => void;
  onPreviousImage: () => void;
  onNextImage: () => void;
  productName: string;
}

const ProductImages: React.FC<ProductImagesProps> = ({
  images,
  selectedImage,
  onImageSelect,
  onPreviousImage,
  onNextImage,
  productName
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="product-images">
      <div className="main-image-container">
        <img 
          src={images[selectedImage]} 
          alt={productName}
          className="main-image"
        />
        <button 
          className="image-nav prev"
          onClick={onPreviousImage}
          aria-label={t('productDetail.previousImage')}
        >
          <ChevronLeftIcon className="nav-icon" />
        </button>
        <button 
          className="image-nav next"
          onClick={onNextImage}
          aria-label={t('productDetail.nextImage')}
        >
          <ChevronRightIcon className="nav-icon" />
        </button>
      </div>
      
      <div className="thumbnail-images">
        {images.map((image, index) => (
          <button
            key={index}
            className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
            onClick={() => onImageSelect(index)}
            aria-label={t('productDetail.viewImage', { number: index + 1 })}
          >
            <img src={image} alt={`${productName} ${index + 1}`} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductImages;
